import { COLLECTION_LINE_CONFIG } from './constants';
import { CollectionLineEntry } from './constants.d'

export const getCollectionLineConfig: (id: string) => CollectionLineEntry | undefined
    = (id: string) => COLLECTION_LINE_CONFIG[id]
        || { collectionName: '', svgClassName: '', tooltipImageClassname: '' };